import React from 'react'
import { RiskHorizontalDisplay } from '../../components/Common'
import RiskActionDetails from '../../components/RiskActionDetails'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import moment from 'moment'

const RiskPdf2 = props => {
  const { dataActions, type, riskStore } = props
  const { riskUnitsV2 } = riskStore
  const riskDetail = toJS(props.riskDetail)
  return (
    <div id={'riskDivToPrint'} style={{ fontSize: '10px !important ' }}>
      <RiskHorizontalDisplay
        labels={[
          {
            image: (
              <img
                id="logo"
                style={{ width: '250px' }}
                src={`${window.location.protocol}//${window.location.host}/assets/photos/logo_vimc.png`}
              />
            ),
            style: { margin: '10px 10px', border: '1px solid black' },
          },
          {
            value: (
              <div style={{ textAlign: 'center' }}>
                <h2>Phiếu kiểm soát rủi ro</h2>
                <div>
                  Số:{String('0' + riskDetail.risk_index).slice(-2)} Ngày{' '}
                  {moment(riskDetail.created_at).format('DD/MM/YYYY')} Giờ{' '}
                  {moment(riskDetail.created_at).format('HH:mm')}
                </div>
              </div>
            ),
            style: { margin: '10px 54px', border: '1px solid black' },
          },
        ]}
        tableStyle={{ margin: '0 0 20px 0', width: '100%' }}
      />
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <>
                {' '}
                <h5>A. Tuyến phòng vệ thứ nhất</h5>
                <RiskActionDetails
                  type={type}
                  data={dataActions?.tier1}
                  riskUnitsV2={riskUnitsV2}
                  tier={'1'}
                  isPartOfPdf
                />
              </>
            ),
            style: {
              textAlign: 'flex',
              border: '1px solid black',
              margin: '0 10px',
            },
          },
        ]}
        tableStyle={{ margin: 0 }}
      />
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <>
                <h5 style={{ marginTop: 16 }}>B. Tuyến phòng vệ thứ hai</h5>
                <RiskActionDetails
                  type={type}
                  data={dataActions?.tier2}
                  tier={'2'}
                  isPartOfPdf
                />
              </>
            ),
            style: {
              textAlign: 'flex',
              border: '1px solid black',
              margin: '0 10px',
            },
          },
        ]}
        tableStyle={{ marginTop: 1000 }}
      />
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <>
                <h5 style={{ marginTop: 16 }}>C. Tuyến phòng vệ thứ ba</h5>
                <RiskActionDetails
                  data={dataActions?.tier3}
                  tier={'3'}
                  isPartOfPdf
                />
              </>
            ),
            style: {
              textAlign: 'flex',
              border: '1px solid black',
              margin: '0 10px',
            },
          },
        ]}
        tableStyle={{ marginTop: 1000 }}
      />
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <>
                <RiskActionDetails
                  data={dataActions?.tier4}
                  tier={'4'}
                  isPartOfPdf
                />
              </>
            ),
            style: {
              textAlign: 'flex',
              border: '1px solid black',
              margin: '0 10px',
            },
          },
        ]}
        tableStyle={{ marginTop: 1000 }}
      />
    </div>
  )
}
RiskPdf2.propTypes = {}

export default inject('riskStore')(observer(RiskPdf2))
